import { SVGProps, Ref, forwardRef } from 'react';

export const CloudFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M10.167 1.003a4.5 4.5 0 0 1 4.11 6.33A4.25 4.25 0 0 1 11.75 15h-7.5a4.25 4.25 0 0 1-2.143-7.92 3.25 3.25 0 0 1 4.205-3.9 4.5 4.5 0 0 1 3.855-2.177"
            fill="currentColor"
        />
    </svg>
));
CloudFilledSize16Glyph.displayName = 'CloudFilledSize16Glyph';
